// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin (webpack.config.js)
import LoginForm from "./LoginForm-APP_CLIENT";

export default LoginForm;
